/**
 * Copyright (C) 2026 Checkmk GmbH - License: Checkmk Enterprise License
 * This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
 * conditions defined in the file COPYING, which is part of this source code package.
 */
import type { paths } from 'cmk-ai-control-plane/typescript/openapi'

import { type FastApiClient, createFastApiClient } from '@/lib/fastapi-client/client'

export type ControlPlaneClient = FastApiClient<paths>

export function createControlPlaneClient(): ControlPlaneClient {
  return createFastApiClient<paths>({
    baseUrl: new URL('ai-control-plane', window.location.href).href
  })
}
